const ERROR_TYPE_TO_STATUS = {
  LESSON_NOT_FOUND: 404,
  LESSON_VISIBILITY_RESTRICTED: 403
};
export const unwrapPublicLessonChirpError = ({
  error,
  data
}) => {
  if (error) {
    var _error$cause;
    const errorType = error === null || error === void 0 || (_error$cause = error.cause) === null || _error$cause === void 0 || (_error$cause = _error$cause.cause) === null || _error$cause === void 0 || (_error$cause = _error$cause.cause) === null || _error$cause === void 0 ? void 0 : _error$cause.errorType;
    const status = ERROR_TYPE_TO_STATUS[errorType] || 500;
    return {
      lesson: undefined,
      lessonError: Object.assign({
        status
      }, error.networkError && {
        networkError: error.networkError
      })
    };
  }
  if (!(data !== null && data !== void 0 && data.lesson)) {
    return {
      lesson: undefined,
      lessonError: !data ? undefined : {
        status: 404
      }
    };
  }
  return {
    lesson: data.lesson,
    lessonError: undefined
  };
};